import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '../assets/styl/main.styl'

Vue.use(Vuetify, {
  iconfont: 'fa',
  icons: {
    'person': 'fa fa-user',
    'lock': 'fa fa-lock'
  },
  theme: {
    primary: '#247BA0',
    secondary: '#EBEDEF',
    accent: '#DACEA7',
    error: '#FB3640',
    background: '#273747'
  }
})
